module.exports = __webpack_public_path__ + "static/comingsoon-afce4f8f48f9c9cd82fb2fe44e00f10a.jpg";